module.exports = __webpack_public_path__ + "media/styles/images/svg/circle-ex-red-on-transparent-5ee161807fb563f4c6864494e28a1b5b.svg";